import { BaseError } from "./base-error.js";
export class BadRequestError extends BaseError {
    static code = 'BadRequestError';
    static statusCode = 400;
    data;
    constructor(message = 'Bad Request', data, options = {}) {
        super(message, options);
        this.data = data;
    }
    get validation() {
        return this.data && (this.data.validation ?? this.data.errors);
    }
    get validationMessages() {
        return this.validation || null;
    }
}
